import { render, staticRenderFns } from "./left-third.vue?vue&type=template&id=0799b106&scoped=true&"
import script from "./left-third.vue?vue&type=script&lang=js&"
export * from "./left-third.vue?vue&type=script&lang=js&"
import style0 from "./left-third.vue?vue&type=style&index=0&id=0799b106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799b106",
  null
  
)

export default component.exports